import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import type { AxiosRequestConfig } from 'axios';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { Organization } from '@/types/organization';
import { utils } from '../../utils';

const validate = () => {};

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  membershipOnly?: boolean;
};

type Response = Organization[];

// The service resolves current memberships when requested, while default
// staff directory requests retain their separate server-side grant.
export const getOrganizations = async (
  { limit = 1000, membershipOnly = false }: RequestParams = {},
  options: Pick<AxiosRequestConfig, 'operationRequirement' | 'signal'> = {}
): Promise<EndpointResponse<Response>> => {
  try {
    validate();

    const result = await scopedApi(GLOBAL_SCOPE).get<EndpointResponse<Response>>(
      `organization?limit=${limit}${membershipOnly ? '&user_only=1' : ''}`,
      options
    );
    if (result.data.isError) return result.data;

    const organizations = result.data.result || [];

    return {
      ...result.data,
      result: organizations,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
